<div
  [class]="selectedColor()"
  class="size-[60px] md:size-[80px] mx-auto text-white text-4xl my-2 flex justify-center items-center rounded-full pointer-events-none border-4 border-white shadow-lg/30"
>
  <p class="semibold pointer-events-none">{{ this.name()[0] }}</p>
</div>
